import { Observable } from 'rxjs';

export abstract class DccAdapter {
  abstract getData(productData: string): Observable<any>;
}
